import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import React, { useState } from 'react';

interface ICheckBoxCompProps {
    id: string;
    label: string;
    objDTO?: any;
    setValue: (value: any) => void;
    disabled?: boolean;
    defaultChecked?: boolean;
}

export const CheckBoxComp: React.FC<ICheckBoxCompProps> = ({
    id,
    label,
    objDTO,
    setValue,
    disabled,
    defaultChecked
}) => {
    // Use o estado local para controlar o estado do Checkbox
    const [checked, setChecked] = useState(defaultChecked || false);

    const handleCheckedChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newChecked = event.target.checked;
        setChecked(newChecked);
        // Atualize o valor usando a função setValue passada como prop
        setValue(objDTO ? { ...objDTO, [id]: newChecked } : newChecked);
    };

    return (
        <React.Fragment>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            id={id}
                            checked={checked}
                            onChange={handleCheckedChange}
                            disabled={disabled}
                        />
                    }
                    label={label}
                />
            </FormGroup>
        </React.Fragment>
    );
};
